import _Object$assign from 'babel-runtime/core-js/object/assign';
/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import svg_close from 'ikonate/icons/close.svg';
import svg_refresh from 'ikonate/icons/refresh.svg';
import { makeIcon } from './icon';
export function makeCloseButton(options = {}) {
    return makeIcon(_Object$assign({ svg: svg_close }, options));
}
export function makeRefreshButton(options = {}) {
    return makeIcon(_Object$assign({ svg: svg_refresh }, options));
}
//# sourceMappingURL=close_button.js.map